/**
 * @file
 * Global utilities.
 *
 */

import 'magnific-popup';
import 'slick-slider';
import 'slick-lightbox';
import 'select2';

(function ($, Drupal, drupalSettings) {
  'use strict';

  function truncateHTML(html, maxLength) {
    let truncated = '';
    let openTags = [];

    let parser = new DOMParser();
    let doc = parser.parseFromString(html, 'text/html');
    let nodes = doc.body.childNodes;

    for (let i = 0; i < nodes.length; i++) {
      let node = nodes[i];

      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent.trim();

        if (truncated.length + text.length < maxLength) {
          truncated += text;
        } else {
          truncated += text.substring(0, maxLength - truncated.length);
          break;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        let tag = node.tagName.toLowerCase();

        if (tag === 'br') {
          truncated += '<br>';
        } else {
          if (node.hasChildNodes()) {
            openTags.push(tag);
            let content = truncateHTML(node.innerHTML, maxLength - truncated.length);
            truncated += '<' + tag + '>' + content + ' ...</' + tag + '>';
            openTags.pop();
          } else {
            truncated += '<' + tag + '></' + tag + '>';
          }
        }

        if (truncated.length >= maxLength) {
          break;
        }
      }
    }

    while (openTags.length > 0) {
      let tag = openTags.pop();
      truncated += '</' + tag + '>';
    }

    return truncated;
  }

  Drupal.bt = {};
  // Slider.
  Drupal.bt.slick = function () {
    $('.slick-single-item').slick({
      arrows: false,
      dots: true,
      infinite: false,
    });
  };
  // Select2.
  Drupal.bt.select2 = function () {
    $('.select2-simple').select2({
      language: {
        noResults: function () {
          return "Pas de résultats";
        }
      }
    });
    $('.select2-nosearch').select2({
      minimumResultsForSearch: -1,
      language: {
        noResults: function () {
          return "Pas de résultats";
        }
      }
    });
    $('.select2-nosearch-views').select2({
      theme: 'views',
      minimumResultsForSearch: -1,
      language: {
        noResults: function () {
          return "Pas de résultats";
        },
      }
    });
    $('.select2-views-basin').select2({
      theme: 'views-basin',
      minimumResultsForSearch: -1,
      language: {
        noResults: function () {
          return "Pas de résultats";
        },
      },
      templateSelection: function (data) {
        var label = $(data.element).closest('select').data('label');
        return label;
      }
    });

    function formatOption(option) {
      var separator = '||SVG||';
      var parts = option.text.split(separator);

      var optionElement = document.createElement('span');

      if (parts.length > 1) {
        var svg = parts[0];
        var text = parts[1];
        optionElement.innerHTML = svg + ' ' + text;
        optionElement.title = text;
      } else {
        optionElement.textContent = option.text;
      }

      return optionElement;
    }

    $('.select2-basin-views-rubrics').select2({
      theme: 'basin-views-rubrics',
      minimumResultsForSearch: -1,
      language: {
        noResults: function () {
          return "Pas de résultats";
        },
      },
      templateResult: formatOption,
      templateSelection: formatOption,
    });

    $('.select2-nosearch-basins').select2({
      theme: 'basins',
      minimumResultsForSearch: -1,
      language: {
        noResults: function () {
          return "Pas de résultats";
        },
      }
    })
      .on('select2:opening', function () {
        console.log($(".select2-nosearch-basins option[value='']"));
        $(".select2-nosearch-basins option[value='']").text('');
      })

    $('.select2-nosearch-views').each(function () {
      var selectedVal = $(this).val();
      if (selectedVal === "All" || selectedVal === "") {
        var labelText = $(this).closest('.js-form-item').find('label').text();
        $(this).next('.select2-container').find('.select2-selection__rendered').text(labelText);
      }
    });

    $('.select2-companies').select2({
      ajax: {
        url: '/companies/list',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            page: params.page
          };
        },
        processResults: function (data) {
          return {
            results: data.items
          };
        },
        cache: true
      },
      minimumInputLength: 3,
      language: {
        inputTooShort: function (args) {
          var remainingChars = args.minimum - args.input.length;
          return 'Veuillez saisir ' + remainingChars + ' caractères supplémentaires';
        },
        noResults: function () {
          return "Pas de résultats";
        },
        loadingMore: function () {
          return "Chargement...";
        },
        searching: function () {
          return "Recherche...";
        },
      }
    });

  };
  // Style label.
  Drupal.bt.label = function () {
    let fields = 'input[type=text], input[type=email], input[type=tel], input[type=password], input[type=number], textarea, select';
    $(fields).focusin(function () {
      $(this).prev('label').addClass('focus');
    });
    $(fields).focusout(function () {
      if ($(this).val().length === 0) {
        $(this).prev('label').removeClass('focus');
      }
    });
    $.each($(fields), function () {
      if ($(this).val() != null && $(this).val().length !== 0) {
        $(this).prev('label').addClass('focus');
      }
    });
    $('select').change(function () {
      if ($(this).val() != null && $(this).val().length !== 0) {
        $(this).prev('label').addClass('focus');
      } else {
        $(this).prev('label').removeClass('focus');
      }
    });
  };

  // Tree Select
  Drupal.bt.treeSelect = function () {
    if ($('.dl-menuwrapper').length) {
      $('.dl-menuwrapper').dlmenu();
    }
  };

  // Checkboxes basins.
  Drupal.bt.moreBasins = function () {
    $('.more-basins').each(function () {
      let link = $(this);
      let checkboxes = link.siblings('.form-checkboxes');
      let tabPane = checkboxes.parents('details.horizontal-tabs-pane');

      let maxHeight = window.getComputedStyle(checkboxes[0], null).getPropertyValue("max-height");
      maxHeight = parseInt(maxHeight, 10);
      let originalTabPaneDisplay, originalTabPanePosition;

      // Vérifier si tabPane existe et enregistrer les styles actuels
      if (tabPane.length > 0) {
        originalTabPaneDisplay = tabPane.css("display");
        originalTabPanePosition = tabPane.css("position");

        // Rendre l'élément temporairement visible pour le calcul de la hauteur
        tabPane.css({display: "block", position: "absolute", visibility: "hidden"});
      }

      checkboxes.css("max-height", "none");
      let realHeight = checkboxes.outerHeight();

      // Restaurer les styles originaux si tabPane existe
      if (tabPane.length > 0) {
        tabPane.css({display: originalTabPaneDisplay, position: originalTabPanePosition, visibility: "visible"});
      }

      checkboxes.css("max-height", maxHeight);

      if (maxHeight >= realHeight) {
        link.hide();
      }
    });


    $('.more-basins').off('click').click(function () {
      console.log('salutbébé');
      let link = $(this);
      let checkboxes = link.siblings('.form-checkboxes');
      let maxHeight = window.getComputedStyle(checkboxes[0], null).getPropertyValue("max-height");
      checkboxes.css("max-height", "none");
      let realHeight = checkboxes.outerHeight();
      checkboxes.animate({maxHeight: realHeight}, 200);
      checkboxes.css("max-height", maxHeight);
      link.hide(200, function () {
        link.remove();
      });
    });
  };

  // More descriptions entreprise/réalisation.
  Drupal.bt.moreDescription = function () {
    const description = $('.full-company__description > div, .full-project__description > div');

    if (description.length && description.html().length > 300) {
      let link = $('.more-description');
      let linkLess = $('.less-description');
      let parentSpan = link.parent('span');
      parentSpan.removeClass('hidden').addClass('block');

      description.data('full-text', description.html());
      let visibleText = description.data('full-text').slice(0, 300) + '...';
      description.html(visibleText);

      let isShowingFullText = false; // initialize variable

      const toggleDescription = () => {
        let fullText = description.data('full-text');
        isShowingFullText = !isShowingFullText; // toggle variable
        let height = description.height();

        description.css({'height': 'auto', 'overflow': 'hidden'}).html(isShowingFullText ? fullText : visibleText); // toggle HTML content
        let newHeight = description.height();
        description.css({'height': height, 'overflow': 'hidden'}).stop().animate({'height': newHeight}, 200, () => {
          description.css({'height': 'auto', 'overflow': 'visible'});
        });

        link.toggleClass('hidden', isShowingFullText);
        linkLess.toggleClass('hidden', !isShowingFullText);
      };

      link.on('click', toggleDescription);
      linkLess.on('click', toggleDescription);
    }
  };

  Drupal.bt.moreJobs = function () {
    const jobs = $('.full-company__jobs');

    if (jobs.length && jobs.html().length > 300) {
      let link = $('.more-jobs');
      let linkLess = link.siblings('.less-jobs');
      let parentSpan = link.parent('span');
      parentSpan.removeClass('hidden').addClass('block');

      jobs.data('full-text', jobs.html());
      let visibleText = jobs.data('full-text').slice(0, 300) + '...';
      jobs.html(visibleText);

      let isShowingFullText = false; // initialize variable

      const toggleJobs = () => {
        let fullText = jobs.data('full-text');
        isShowingFullText = !isShowingFullText; // toggle variable
        let height = jobs.height();

        jobs.css({'height': 'auto', 'overflow': 'hidden'}).html(isShowingFullText ? fullText : visibleText); // toggle HTML content
        let newHeight = jobs.height();
        jobs.css({'height': height, 'overflow': 'hidden'}).stop().animate({'height': newHeight}, 200, () => {
          jobs.css({'height': 'auto', 'overflow': 'visible'});
        });

        link.toggleClass('hidden', isShowingFullText);
        linkLess.toggleClass('hidden', !isShowingFullText);
      };

      link.on('click', toggleJobs);
      linkLess.on('click', toggleJobs);
    }
  };

  Drupal.bt.hoverContact = function () {
    let contact = $('.company__floating-box .contact');
    if (contact.length) {
      $('.contact__animation').on('click', function (e) {
        if (!$(this).hasClass('contact__animation-active')) {
          $(this).addClass('contact__animation-active');
          $(this).parent('.contact').addClass('contact-nogap');
          $(this).siblings('span').addClass('contact__animation-hide');
        } else {
          $(this).removeClass('contact__animation-active');
          $(this).parent('.contact').removeClass('contact-nogap');
          $(this).siblings('span').removeClass('contact__animation-hide');
        }
      });
    }
  }

  Drupal.behaviors.batitertiaire = {
    attach: function (context, settings) {
      // Vérification du contexte car le fichier est parcouru une 2ème fois avec l'élément HTML de la barre admin
      // comme contexte. En vérifiant que context est bien égal à document, on s'assure que la fonction ne sera lue qu'une fois
      // @see https://drupal.stackexchange.com/a/287227
      if (context === document) {
        // Scroll on page load if URL contains anchor
        if (window.location.hash) {
          var target = $(window.location.hash);
          if (target.length) {
            var targetOffset = target.offset().top - 160;
            var scrollTime = 500;
            $('html, body').animate({
              scrollTop: targetOffset
            }, scrollTime);
          }
        }

        // Smooth scroll.
        $('a[href^="#"]').click(function (event) {
          event.preventDefault();
          var target = $(this.hash);
          if (target.length) {
            var targetOffset = target.offset().top - 80;
            var scrollTime = 500;
            $('html, body').animate({
              scrollTop: targetOffset
            }, scrollTime);
          }
        });

        // Script Matomo.
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
          var u = "https://batitertiaire.matomo.cloud/";
          _paq.push(['setTrackerUrl', u + 'matomo.php']);
          _paq.push(['setSiteId', '1']);
          var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
          g.async = true;
          g.src = '//cdn.matomo.cloud/batitertiaire.matomo.cloud/matomo.js';
          s.parentNode.insertBefore(g, s);
        })();

        Drupal.bt.treeSelect();
        Drupal.bt.moreBasins();
        Drupal.bt.moreDescription();
        Drupal.bt.moreJobs();
        Drupal.bt.label();
        Drupal.bt.hoverContact();

        $('.horizontal-tab-button').click(function () {
          Drupal.bt.moreBasins();
          setTimeout(function () {
            Drupal.bt.moreBasins();
            // Votre code de mesure de hauteur ici
          }, 0);
        });

        // Popup.
        // $('.ajax-popup').magnificPopup({
        //   type: 'ajax',
        //   overflowY: 'auto',
        //   closeBtnInside: true,
        //   mainClass: 'mfp-fade',
        //   callbacks: {
        //     ajaxContentAdded: function() {
        //       Drupal.bt.slick();
        //     }
        //   }
        // });
        var observer = new MutationObserver(function (mutations) {
          // si l'élément est trouvé, exécutez votre code jQuery et arrêtez d'observer
          if ($('.ajax-popup').length) {
            $('.ajax-popup').magnificPopup({
              type: 'ajax',
              overflowY: 'auto',
              closeBtnInside: true,
              mainClass: 'mfp-fade',
              callbacks: {
                ajaxContentAdded: function () {
                  Drupal.bt.slick();
                }
              }
            });
            observer.disconnect();
          }
        });
        observer.observe(document.querySelector('header'), {subtree: true, childList: true});

        $('.video-popup').magnificPopup({
          type: 'iframe',
          removalDelay: 160,
          showCloseBtn: true
        });

        // Pour la page "Mon compte" on affiche un message si on change les jobs.
        if ($('.b2i_user-account-edit').length) {
          $('[data-drupal-selector="edit-main-job"], [data-drupal-selector="edit-other-jobs"]').on('change', function () {
            $('#jobs-info').show();
          });
          const passwordField = document.querySelector("#edit-password");
          const passwordFieldConfirm = document.querySelector("#edit-password-confirm");
          if (passwordField) {
            passwordField.value = "";
            passwordFieldConfirm.value = "";
          }
        }

        $('a[data-drupal-selector="edit-not-find-job"]').magnificPopup({
          items: {
            src: '#block-not-find-job',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });
        $('a[data-drupal-selector="edit-not-find-qualifications"]').magnificPopup({
          items: {
            src: '#block-not-find-qualifications',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });
        $('a[data-drupal-selector="edit-declarer-un-contenu-abusif"]').magnificPopup({
          items: {
            src: '#block-declarer-un-contenu-abusif',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });
        $('a[data-drupal-selector="edit-contacter-une-entreprise"]').magnificPopup({
          items: {
            src: '#block-contacter-une-entreprise',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });
        $('a[data-drupal-selector="be-informed-basin"]').magnificPopup({
          items: {
            src: '#block-be-informed-basin',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });
        $('#participate-button').magnificPopup({
          items: {
            src: '#block-participate',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          },
          callbacks: {
            close: function () {
              location.reload();  // Recharge la page
            }
          }
        });
        $('.collaboration-button-accept-popup').magnificPopup({
          items: {
            src: '#block-acceptance',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          },
          callbacks: {
            close: function () {
              location.reload();  // Recharge la page
            }
          }
        });
        $('.open-popup-toggle').magnificPopup({
          items: {
            src: '.popup-toggle',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          },
        });
        if ($('#b2i_follow_company-message').length) {
          $.magnificPopup.open({
            items: {
              src: '#b2i_follow_company-message',
              type: 'inline',
              overflowY: 'auto',
              mainClass: 'mfp-fade',
            },
          });
        }
        $('body').on('click', '.mfp-close-click', function () {
          $.magnificPopup.close();
        });
        if ($('.mfp-close-registration').length) {
          $('.mfp-close-registration', context).on('click', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
            var url = $(this).data('src');
            console.log(url);
            setTimeout(function () {
              $.magnificPopup.open({
                items: {
                  src: url,
                },
                type: 'ajax',
                overflowY: 'auto',
                closeBtnInside: true,
                mainClass: 'mfp-fade',
                callbacks: {
                  ajaxContentAdded: function () {
                    Drupal.bt.slick();
                  }
                }
              });
            }, 200);
          });
        }
        $('#button-help').magnificPopup({
          items: {
            src: '#popup-help',
            type: 'inline',
            overflowY: 'auto',
            mainClass: 'mfp-fade',
          }
        });

        // Popup-published.
        if ($('#block-popup-published').length) {
          var urlParams = new URLSearchParams(window.location.search);
          var isPublished = urlParams.get('published');

          if (isPublished === '1') {
            // Déclenchez la popup.
            $.magnificPopup.open({
              items: {
                src: '#block-popup-published', // Votre template de popup ici.
                type: 'inline',
                overflowY: 'auto',
                mainClass: 'mfp-fade',
              }
            });
          }
          // Supprimez le paramètre 'published' de l'URL.
          urlParams.delete('published');
          var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname
          history.replaceState({}, '', newUrl);
        }

        // If .popup-closed-basin exist, open popup.
        if ($('.popup-closed-basin').length) {
          $.magnificPopup.open({
            items: {
              src: '.popup-closed-basin',
              type: 'inline',
              overflowY: 'auto',
              mainClass: 'mfp-fade',
            },
            closeOnBgClick: false,
            closeOnContentClick: false,
            enableEscapeKey: false,
            closeMarkup: '',
          });
        }


        $('.b2i_user-collaborations-view .form-radio').click(function () {
          $('.b2i_user-collaborations-view .form-item-company input').val($(this).val());
        });

        // Scroll to.
        $('.scroll-to').click(function () {
          $('html, body').animate({
            scrollTop: $('#to-scroll').offset().top - 105
          }, 300);
        });
        // Scroll top.
        $('.scroll-top').click(function () {
          $('html, body').animate({
            scrollTop: $('body').offset().top
          }, 300);
        });

        // Modal Drupal.
        $(document).on('click', '.ui-widget-overlay', function () {
          $('.ui-dialog-content').dialog('close');
        });

        // Floating box entreprise.
        if ($('.company__floating-box_container').length) {
          var containerPosition = $('.company__floating-box_container').position().top;
          var mainHeight = $('main').height();
          var pageHeight = mainHeight - containerPosition - 350;
          if ($('.company-full').height()) {
            pageHeight = mainHeight - containerPosition - 700;
          }
          $('.company__floating-box_container').css({
            'height': pageHeight,
            'bottom': -pageHeight
          });
          $('.company__floating-box').on('click', '.button-up', function (e) {
            $('.company__floating-box').toggleClass('active');
          });
        }

        // Slicks.
        if ($('.realisation-full').length) {
          // Slider light.
          $('#slick-mobile').slick({
            // Options de slick.
          });
          $('#slick-lightbox').slickLightbox({
            src: 'data-src',
            itemSelector: 'span',
            navigateByKeyboard: true,
            caption: function (element, info) {
              let currentSlide = info.index + 1;
              let totalSlide = info.length;
              return currentSlide + '/' + totalSlide;
            }
          });
          $('.nbr-photo, .full-project__photos img, #slick-mobile img').on('click', function (e) {
            e.preventDefault();
            var index = 0;
            if (!$(this).hasClass('nbr-photo')) {
              index = $(this).parent('div').index();
            }
            $('#slick-lightbox span').eq(index).trigger('click');
          });
        }
        if ($('.views__block-they-joined').length) {
          $('.views__block-they-joined').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                }
              },
            ]
          });
        }
        if ($('.views__block-basin').length) {
          $('.views__block-basin').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
          });
        }
        if ($('.views__block-rubrics').length) {
          $('.views__block-rubrics').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 375,
                settings: {
                  slidesToShow: 2,
                }
              },
            ]
          });
        }

        // Managed files (multiple).
        $(document).on('click', '.managed-file--square-add', function () {
          if ($(this).parents('table').length) {
            $(this).parents('table').next('.js-form-type-managed-file').find('.managed-file--button-add').click();
          } else {
            $(this).next('.js-form-type-managed-file').find('.managed-file--button-add').click();
          }
        });

        // Menu.
        $(document).on('click', function (event) {
          if (!$(event.target).closest('#menu-toggle, #menu-profile').length && $('#menu-toggle').css('position') == 'absolute') {
            $('#menu-toggle').hide();
          }
        });
        $(document).on('click', '#menu-profile', function () {
          if ($('#menu-toggle').css('position') == 'absolute') {
            $(this).toggleClass('open');
            $('#menu-toggle').toggle();
          }
        });

        // Menu mobile.
        $(document).on('click', '#nav-icon', function () {
          const navIcon = $(this);
          const menuBurger = navIcon.closest('.menu-burger');
          const targetDiv = menuBurger.next();

          if (!navIcon.hasClass('open')) {
            navIcon.addClass('open');
            targetDiv.css('left', '0');
          } else {
            navIcon.removeClass('open');
            targetDiv.css('left', '100%');
          }
        });

        // Invitations.
        var attempts = 0;
        var checkExist = setInterval(function () {
          if ($('header .count-invitation').length) {
            attempts++;
            $.ajax({
              url: '/collaboration/count',
              type: 'GET',
              dataType: 'json',
              success: function (data) {
                var invitationCount = data;
                if (invitationCount > 0) {
                  var spanElement = $('<span/>').addClass('invitations_count').text(invitationCount).css('margin-left', '1rem');
                  $('.count-invitation').append(spanElement);
                }
              }
            });
            clearInterval(checkExist);
          } else if (attempts >= 3) {
            clearInterval(checkExist);
          }
        }, 1000);

        // b2i_statistics.
        $('.count-click', context).click(function (e) {
          if ($(this).hasClass('contact__animation-active')) {
            var nodeId = $(this).data('count-id');
            var type = $(this).data('count-type');

            $.ajax({
              url: Drupal.url('b2i_statistics/click/' + nodeId + '/' + type),
              type: 'POST',
              dataType: 'json',
              success: function (response) {
                console.log(response);
              }
            });
          }
        });

        // Click sur onglet.
        if ($('.horizontal-tabs').length) {
          var hash = window.location.hash;
          if (hash != '') {
            var tab = $('a[href="' + hash + '"]');
            if (tab.length > 0) {
              tab.click();
            }
          }
        }

      }

      $(document).bind('leaflet.map', function (event, map, lMap) {
        setTimeout(function () {
          var currentZoom = lMap.getZoom();
          lMap.setZoom(currentZoom + 1);
        }, 1000);
        lMap.eachLayer(function (layer) {
          if (layer instanceof L.Marker) {
            layer.on('click', function (e) {
              var popup = layer.getPopup();
              var link = $(popup.getContent());
              if (link.hasClass('pending')) {
                $.magnificPopup.open({
                  items: {
                    src: '#block-be-informed-basin'
                  },
                  type: 'inline',
                  overflowY: 'auto',
                  mainClass: 'mfp-fade',
                });
              } else if (link.hasClass('not-pending')) {
                window.location.href = link.attr('href');
              }
            });
          }
        });
      });

      // Besoin de l'appeler en dehors du context document à cause de view ajax.
      Drupal.bt.select2();
      if ($(".click-submit").length) {
        $(".click-submit").click(function (e) {
          $(this).closest("form").find('input[type=submit]').trigger('click');
        });
      }

      $(document).ready(function () {
        // $('.ajax-popup').magnificPopup({
        //   type: 'ajax',
        //   overflowY: 'auto',
        //   closeBtnInside: true,
        //   mainClass: 'mfp-fade',
        //   callbacks: {
        //     ajaxContentAdded: function() {
        //       Drupal.bt.slick();
        //     }
        //   }
        // });
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
